export const getErrors = state => state.errorList;
export const getFatalError = state => state.fatalError;



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/errors/getters.js